var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryCustomerEnablement16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Customer-Enablement_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Customer-Enablement_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Customer-Enablement_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Customer-Enablement_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-8",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Customer-Enablement_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,11.444 L12.226,12.377 C11.796,10.715 10.836,9.424 9.621,8.801 C10.448,8.266 11,7.34 11,6.284 C11,4.63 9.654,3.284 8,3.284 C6.346,3.284 5,4.63 5,6.284 C5,7.328 5.537,8.247 6.349,8.784 C5.124,9.398 4.155,10.69 3.721,12.349 L2,11.444 L2,4.531 L8,1.148 L14,4.531 L14,11.444 Z M6,6.284 C6,5.181 6.897,4.284 8,4.284 C9.103,4.284 10,5.181 10,6.284 C10,7.387 9.103,8.284 8,8.284 C6.897,8.284 6,7.387 6,6.284 L6,6.284 Z M8,14.599 L4.64,12.832 C5.089,10.808 6.419,9.389 7.97,9.389 C9.502,9.389 10.852,10.844 11.302,12.863 L8,14.599 Z M15,3.947 L8,-1.0658141e-14 L1,3.947 L1,12.048 L8,15.729 L12.375,13.428 L12.419,13.423 C12.418,13.418 12.416,13.413 12.416,13.407 L15,12.048 L15,3.947 Z",
    id: "Fill-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryCustomerEnablement16);
export default __webpack_public_path__ + "static/media/Arch-Category_Customer-Enablement_16.a93a11a4f823a3c24ccd1504e4fd185a.svg";
export { ForwardRef as ReactComponent };